import * as units from '../../utils/units.js'

class BoltAndNutButtonComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('project-loaded', async (event) => this.onUpdate(event.detail.boltAndNut), true)
    document.addEventListener('bolt-and-nut-model-update', async (event) => this.onUpdate(event.detail.boltAndNut), true)
  }

  onUpdate(boltAndNutModel) {
    let boltSizeStr = boltAndNutModel.boltType === 'hooked-bolt' ? boltAndNutModel.hookLength : boltAndNutModel.boltDiameterLabel
    let str = '<strong>Anchor Bolt</strong>'
    str += `<div>${boltSizeStr} ${boltAndNutModel.boltTypeStr}</div>`
    if(boltAndNutModel.hasNuts) {
      str += `<div>${boltAndNutModel.nutType} Nut</div>`
    }
    str += `<div>futa = ${boltAndNutModel.tensileStrength} ksi</div>`
    str += `<div>Embed Depth = ${boltAndNutModel.embedDepth} in</div>`
    if(boltAndNutModel.groutPads) { str += '<div>Has Grout Pads</div>'}
    if(boltAndNutModel.weldedToBasePlate) { str += '<div>Anchors Welded to Base Plate</div>' }
    document.getElementById('anchor-bolt-button').innerHTML = str
  }

  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="card">
        <a href="#" data-bs-toggle="modal" data-bs-target="#modal-anchor-bolt-dialog" style="text-decoration: none;">
          <div class="card panel-shadow text-center" style="padding:10px;" id="anchor-bolt-button">
            <strong>Anchor Bolt</strong>
            <div>1/2" Threaded Rod</div>
            <div>Square</div>
            <div>futa = 58.00 ksi</div>
            <div>Embed Depth = 6.00 in</div>
          </div>
        </a>
      </div>
    `
  }
}

customElements.define('bolt-and-nut-button-component', BoltAndNutButtonComponent);